export default __webpack_public_path__ + "static/media/atlanta.d94675c3.png";